// extracted by mini-css-extract-plugin
module.exports = {"container":"_lG","title":"_lH","image":"_lI","imageLogo":"_lJ","info":"_lK","infoContainer":"_lL","infoTitle":"_lM","infoValue":"_lN","goBack":"_lO"};